$(document).ready(function() {
  var collectionListSwiper = new Swiper('.collection-list-swiper', {
    slidesPerView: 2,
    spaceBetween: 8,
    autoplay: false,
    loop: false,
    navigation: {
      nextEl: ".collection-list-swiper .swiper-button-next",
      prevEl: ".collection-list-swiper .swiper-button-prev",
    },
    breakpoints: {
      1025: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
    },
  });
})